module.exports = __webpack_public_path__ + "static/media/close.2699060b.svg";